import React, { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Menu, MenuItem, IconButton, ListItemIcon, ListItemText,
} from '@mui/material';
// component
import { usePrivilege } from '../../../PrivilegeContext';
import ModalDelete from '../../../components/ModalDelete';
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

export default function CampaignsMoreMenu({
  campaign,
  handleSeeMore,
  handleEditOpen,
  handleDeleteOpen,
  handleClose,
  deleteModal,
  handleDelete,
  handleRunCampaign,
}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const { role } = usePrivilege();

  const handleMenuItemClick = (callback) => {
    if (callback) {
      callback(campaign);
    }
    setIsOpen(false);
  };

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {/* View - Show for both On Demand and Published */}
        {(campaign?.status === 'On Demand' || campaign?.status === 'Published') && (
          <MenuItem
            sx={{ color: 'text.secondary' }}
            onClick={() => handleMenuItemClick(handleSeeMore)}
          >
            <ListItemIcon>
              <Iconify icon="heroicons:signal-solid" width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="See More" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}

        {/* Edit - Only show for On Demand */}
        {campaign?.status === 'On Demand' && (role === 900 || role === 101 || role === 111) && (
          <MenuItem
            component={RouterLink}
            to="#"
            sx={{ color: 'text.secondary' }}
            onClick={() => handleMenuItemClick(handleEditOpen)}
          >
            <ListItemIcon>
              <Iconify icon="eva:edit-fill" width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}

        {/* Run Campaign - Only show for On Demand */}
        {campaign?.status === 'On Demand' && (role === 900 || role === 101 || role === 111) && (
          <MenuItem
            sx={{ color: 'text.secondary' }}
            onClick={() => handleMenuItemClick(handleRunCampaign)}
          >
            <ListItemIcon>
              <Iconify icon="eva:play-circle-fill" width={24} height={24} sx={{ color: 'success.main' }} />
            </ListItemIcon>
            <ListItemText primary="Run Campaign" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}

        {/* Delete - Show for both On Demand and Published */}
        {(campaign?.status === 'On Demand' || campaign?.status === 'Published') && (role === 900 || role === 101 || role === 111) && (
          <MenuItem
            sx={{ color: 'text.secondary' }}
            onClick={() => {
              handleDeleteOpen();
            }}
          >
            <ListItemIcon>
              <Iconify icon="eva:trash-2-outline" width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        <ModalDelete
          handleDelete={handleDelete}
          deleteModal={deleteModal}
          data={campaign}
          handleClose={handleClose}
        />
      </Menu>
    </>
  );
}
